import {
  EXAMPLE_ACTION,
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
  LOGIN_ACTION,
  LOGIN_DATA_REQUEST,
  LOGIN_DATA_SUCCESS,
  LOGIN_DATA_FAILURE,
  FETCH_LOCATION_FAILURE,
  FETCH_LOCATION_SUCCESS,
  FETCH_LOCATION_REQUEST,
  FETCH_DISTRICT_LOCATION_SUCCESS,
  FETCH_DISTRICT_LOCATION_FAILURE,
  FETCH_DISTRICT_LOCATION_REQUEST,
  REFRESH_TOKEN_DATA_FAILURE,
  REFRESH_TOKEN_DATA_SUCCESS,
  REFRESH_TOKEN_DATA_REQUEST,
  FORGOT_DATA_FAILURE,
  FORGOT_DATA_SUCCESS,
  FORGOT_DATA_REQUEST,
  RESET_DATA_REQUEST,
  RESET_DATA_SUCCESS,
  RESET_DATA_FAILURE,
  CURRENTUSER_DATA_REQUEST,
  CURRENTUSER_DATA_SUCCESS,
  CURRENTUSER_DATA_FAILURE,
  FETCH_CONTRIBUTION_PLAN_REQUEST,
  FETCH_CONTRIBUTION_PLAN_FAILURE,
  FETCH_CONTRIBUTION_PLAN_SUCCESS,
  FETCH_CONTRIBUTIONBYID_PLAN_REQUEST,
  FETCH_CONTRIBUTIONBYID_PLAN_FAILURE,
  FETCH_CONTRIBUTIONBYID_PLAN_SUCCESS,
  FETCH_INSUREEBYID_REQUEST,
  FETCH_INSUREEBYID_FAILURE,
  FETCH_INSUREEBYID_SUCCESS,
  FETCH_POLICYHOLDERINSUREE_FAILURE,
  FETCH_POLICYHOLDERINSUREE_SUCCESS,
  FETCH_POLICYHOLDERINSUREE_REQUEST,
  FETCH_POLICYHOLDER_USER_REQUEST,
  FETCH_POLICYHOLDER_USER_FAILURE,
  FETCH_POLICYHOLDER_USER_SUCCESS,
  FETCH_MUNICIPALITY_LOCATION_SUCCESS,
  FETCH_MUNICIPALITY_LOCATION_REQUEST,
  FETCH_MUNICIPALITY_LOCATION_FAILURE,
  FETCH_ALL_LOCATION_SUCCESS,
  FETCH_ALL_LOCATION_FAILURE,
  FETCH_ALL_LOCATION_REQUEST,
  FETCH_VILLAGE_LOCATION_SUCCESS,
  FETCH_VILLAGE_LOCATION_REQUEST,
  FETCH_VILLAGE_LOCATION_FAILURE,
  CREATE_POLICYHOLDERINSUREECREATE_FAILURE,
  CREATE_POLICYHOLDERINSUREECREATE_SUCCESS,
  CREATE_POLICYHOLDERINSUREECREATE_REQUEST,
  UPDATE_POLICYHOLDERINSUREEUPDATE_REQUEST,
  UPDATE_POLICYHOLDERINSUREEUPDATE_SUCCESS,
  UPDATE_POLICYHOLDERINSUREEUPDATE_FAILURE,
  DELETE_POLICYHOLDERINSUREEDELETE_REQUEST,
  DELETE_POLICYHOLDERINSUREEDELETE_SUCCESS,
  DELETE_POLICYHOLDERINSUREEDELETE_FAILURE,
  PRINT_INSUREE_REQUEST,
  PRINT_INSUREE_FAILURE,
  PRINT_INSUREE_SUCCESS,
  PRINT_POLICYHOLDER_REQUEST,
  PRINT_POLICYHOLDER_FAILURE,
  PRINT_POLICYHOLDER_SUCCESS,
  DOCUMENT_FILE_RESP,
  TEMPLATE_FILE_RESP,
  CORE_MUTATION_RESP,
  DOCUMENT_DOCUMENTS_RESP,
  UPLOAD_FILE_RESP,
  DELETE_FILE_RESP,
  FETCH_CONTRACT_REQUEST,
  FETCH_CONTRACT_FAILURE,
  FETCH_CONTRACT_SUCCESS,
  FETCH_PAYEMTS_FAILURE,
  FETCH_PAYEMTS_SUCCESS,
  FETCH_PAYEMTS_REQUEST,
  FETCH_PAYEMTSBYID_FAILURE,
  FETCH_PAYEMTSBYID_SUCCESS,
  FETCH_PAYEMTSBYID_REQUEST,
  FETCH_ENDATE_REQUEST,
  FETCH_ENDATE_FAILURE,
  FETCH_ENDATE_SUCCESS,
  FETCH_CREATE_CONTRACT_SUCCESS,
  FETCH_CREATE_CONTRACT_FAILURE,
  FETCH_CREATE_CONTRACT_REQUEST,
  FETCH_CONTRACT_DETAILS_SUCCESS,
  FETCH_CONTRACT_DETAILS_FAILURE,
  FETCH_CONTRACT_DETAILS_REQUEST,
  FETCH_POLICYHOLDER_INSUREE_SUCCESS,
  FETCH_POLICYHOLDER_INSUREE_FAILURE,
  FETCH_POLICYHOLDER_INSUREE_REQUEST,
  INITIALIZE_ROUTES,
  FETCH_CONTRACT_DELETE_FAILURE,
  FETCH_CONTRACT_DELETE_SUCCESS,
  FETCH_CONTRACT_DELETE_REQUEST,
  UPDATE_PAYMENT_REQUEST,
  UPDATE_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_FAILURE,
  SUBMIT_CONTRACT_FAILURE,
  SUBMIT_CONTRACT_SUCCESS,
  SUBMIT_CONTRACT_REQUEST,
  DELETE_CONTRACT_DETAIL_FAILURE,
  DELETE_CONTRACT_DETAIL_SUCCESS,
  DELETE_CONTRACT_DETAIL_REQUEST,
  FETCH_USER_VALIDATION_FAILURE,
  FETCH_USER_VALIDATION_REQUEST,
  FETCH_USER_VALIDATION_SUCCESS,
  FETCH_VERIFICATION_DATA_REQUEST,
  FETCH_VERIFICATION_DATA_FAILURE,
  FETCH_VERIFICATION_DATA_SUCCESS,
  CLEAN_VERIFICATION_CODE,
  FETCH_VERIFICATION_CODE_REQUEST,
  FETCH_VERIFICATION_CODE_SUCCESS,
  FETCH_VERIFICATION_CODE_FAILURE,
  FETCH_HEALTH_FACILITIES_REQUEST,
  FETCH_HEALTH_FACILITIES_SUCCESS,
  FETCH_HEALTH_FACILITIES_FAILURE,
  FETCH_VERIFICATION_HISTORY_REQUEST,
  FETCH_VERIFICATION_HISTORY_FAILURE,
  FETCH_VERIFICATION_HISTORY_SUCCESS,
  FETCH_POLICIES_INSUREE_REQUEST,
  FETCH_POLICIES_INSUREE_FAILURE,
  FETCH_POLICIES_INSUREE_SUCCESS,
  FETCH_LATEST_ACTIVE_INSUREE_REQUEST,
  FETCH_LATEST_ACTIVE_INSUREE_SUCCESS,
  FETCH_LATEST_ACTIVE_INSUREE_FAILURE,
  FETCH_GUARDIAN_REQUEST,
  FETCH_GUARDIAN_SUCCESS,
  FETCH_GUARDIAN_FAILURE,
  FETCH_HEALTH_FACILITIES_INUSREE_REQUEST,
  FETCH_HEALTH_FACILITIES_INUSREE_SUCCESS,
  FETCH_HEALTH_FACILITIES_INUSREE_FAILURE,
  FETCH_HEALTH_FACILITIES_INUSREE_STATUS_REQUEST,
  FETCH_HEALTH_FACILITIES_INUSREE_STATUS_SUCCESS,
  FETCH_HEALTH_FACILITIES_INUSREE_STATUS_FAILURE,
  FETCH_CONSULTANT_HF_REQUEST,
  FETCH_CONSULTANT_HF_SUCCESS,
  FETCH_CONSULTANT_HF_FAILURE,
  FETCH_PRINT_CARE_SHEET_REQUEST,
  FETCH_PRINT_CARE_SHEET_SUCCESS,
  FETCH_PRINT_CARE_SHEET_FAILURE,
  CREATE_FOSA_USER_REQUEST,
  CREATE_FOSA_USER_SUCCESS,
  CREATE_FOSA_USER_FAILURE,
  FETCH_CLAIM_TABLE_REQUEST,
  FETCH_CLAIM_TABLE_SUCCESS,
  FETCH_CLAIM_TABLE_FAILURE,
  FETCH_CLAIM_SERVICE_REQUEST,
  FETCH_CLAIM_SERVICE_SUCCESS,
  FETCH_CLAIM_SERVICE_FAILURE,
  FETCH_CLAIM_ITEMS_FAILURE,
  FETCH_CLAIM_ITEMS_SUCCESS,
  FETCH_CLAIM_ITEMS_REQUEST,
  FETCH_PATHOLOGY_REQUEST,
  FETCH_PATHOLOGY_SUCCESS,
  FETCH_PATHOLOGY_FAILURE,
  CREATE_CLAIM_REQUEST,
  CREATE_CLAIM_SUCCESS,
  CREATE_CLAIM_FAILURE,
  FETCH_CLAIMBYID_FAILURE,
  FETCH_CLAIMBYID_SUCCESS,
  FETCH_CLAIMBYID_REQUEST,
  FETCH_CLAIMHISTORYBYID_FAILURE,
  FETCH_CLAIMHISTORYBYID_SUCCESS,
  FETCH_CLAIMHISTORYBYID_REQUEST,
  FETCH_ADMINID_REQUEST,
  FETCH_ADMINID_SUCCESS,
  FETCH_ADMINID_FAILURE,
  FETCH_INSUREEUUID_FAILURE,
  FETCH_INSUREEUUID_SUCCESS,
  FETCH_INSUREEUUID_REQUEST,
  SUBMIT_CLAIM_FAILURE,
  SUBMIT_CLAIM_SUCCESS,
  SUBMIT_CLAIM_REQUEST,
  UPDATE_CLAIM_FAILURE,
  UPDATE_CLAIM_SUCCESS,
  UPDATE_CLAIM_REQUEST,
  CREATE_ATTACHMENT_FAILURE,
  CREATE_ATTACHMENT_SUCCESS,
  CREATE_ATTACHMENT_REQUEST,
  FETCH_ATTACHEMENTS_FAILURE,
  FETCH_ATTACHEMENTS_SUCCESS,
  FETCH_ATTACHEMENTS_REQUEST,
  FETCH_MEDICAL_INSUREE_REQUEST,
  FETCH_MEDICAL_INSUREE_SUCCESS,
  FETCH_MEDICAL_INSUREE_FAILURE,
  GET_CONSULTANT_REQUEST,
  GET_CONSULTANT_SUCCESS,
  GET_CONSULTANT_FAILURE,
  FETCH_FOSA_USER_REQUEST,
  FETCH_FOSA_USER_SUCCESS,
  FETCH_FOSA_USER_FAILURE,
  CLEAR_CARESHEET_DATA,
  CLEAR_CLAIM_RESP,
  CLEAR_PRINT_INSUREE,
  FETCH_PREAUTH_REQUEST,
  FETCH_PREAUTH_SUCCESS,
  FETCH_PREAUTH_FAILURE,
  FETCH_PREAUTHFORM_REQUEST,
  FETCH_PREAUTHFORM_SUCCESS,
  FETCH_PREAUTHFORM_FAILURE,
  FETCH_PREAUTH_HISTORY_FAILURE,
  FETCH_PREAUTH_HISTORY_REQUEST,
  FETCH_PREAUTH_HISTORY_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  GET_PREAUTH_REQUEST,
  GET_PREAUTH_SUCCESS,
  GET_PREAUTH_FAILURE,
  CREATE_PREAUTH_SUCCESS,
  CREATE_PREAUTH_REQUEST,
  CREATE_PREAUTH_FAILURE,
  RESET_CLAIM_STATE,
  FETCH_ADMIN_TABLE_REQUEST,
  FETCH_ADMIN_TABLE_SUCCESS,
  FETCH_ADMIN_TABLE_FAILURE,
  CREATE_ADMIN_REQUEST,
  CREATE_ADMIN_SUCCESS,
  CREATE_ADMIN_FAILURE,
  FETCH_ADMIN_REQUEST,
  FETCH_ADMIN_SUCCESS,
  FETCH_ADMIN_FAILURE,
  EDIT_ADMIN_REQUEST,
  EDIT_ADMIN_SUCCESS,
  EDIT_ADMIN_FAILURE,
  DELETE_ADMIN_REQUEST,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAILURE,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  FETCH_FOSA_MEDICAL_ITEMS_SUCCESS,
  FETCH_FOSA_MEDICAL_ITEMS_FAILURE,
  FETCH_FOSA_MEDICAL_ITEMS_REQUEST,
  FETCH_FOSA_MEDICAL_SERVICES_FAILURE,
  FETCH_FOSA_MEDICAL_SERVICES_SUCCESS,
  FETCH_FOSA_MEDICAL_SERVICES_REQUEST,
  CURRENt_USER_WITH_ROLES_SUCCESS,
  FETCH_SUBSTITUTE_REQUEST,
  FETCH_SUBSTITUTE_SUCCESS,
  FETCH_SUBSTITUTE_FAILURE,
  FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_REQUEST,
  FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_SUCCESS,
  FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_FAILURE,
  CLEAN_SELECTED_INSUREE,
  FETCH_CONVENTIONNEMENT_BY_HF_ID_REQUEST,
  FETCH_CONVENTIONNEMENT_BY_HF_ID_SUCCESS,
  FETCH_CONVENTIONNEMENT_BY_HF_ID_FAILURE,
  FETCH_HEALTH_FACILITIES_PACKAGE_REQUEST,
  FETCH_HEALTH_FACILITIES_PACKAGE_SUCCESS,
  FETCH_HEALTH_FACILITIES_PACKAGE_FAILURE,
  FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_REQUEST,
  FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_SUCCESS,
  FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_FAILURE,
  FETCH_CLAIM_CHAT_REQUEST,
  FETCH_CLAIM_CHAT_SUCCESS,
  FETCH_CLAIM_CHAT_FAILURE,
  CREATE_CLAIM_CHAT_REQUEST,
  CREATE_CLAIM_CHAT_SUCCESS,
  CREATE_CLAIM_CHAT_FAILURE,
  RESET_USERNAME_ERROR,
} from "./types";

export const exampleAction = (payload) => ({
  type: EXAMPLE_ACTION,
  payload,
});

export const fetchDataRequest = () => ({
  type: FETCH_DATA_REQUEST,
});

export const fetchDataSuccess = (data) => ({
  type: FETCH_DATA_SUCCESS,
  payload: data,
});

export const clearDataSuccess = (data) => ({
  type: FETCH_DATA_SUCCESS,
  payload: data,
});

export const fetchDataFailure = (error) => ({
  type: FETCH_DATA_FAILURE,
  payload: error,
});

export const fetchLoginDataRequest = () => ({
  type: LOGIN_DATA_REQUEST,
});

export const fetchLoginDataSuccess = (data) => ({
  type: LOGIN_DATA_SUCCESS,
  payload: data,
});

export const fetchLoginDataFailure = (error) => ({
  type: LOGIN_DATA_FAILURE,
  payload: error,
});

export const fetchForgotDataRequest = () => ({
  type: FORGOT_DATA_REQUEST,
});

export const fetchForgotDataSuccess = (data) => ({
  type: FORGOT_DATA_SUCCESS,
  payload: data,
});
export const ClearForgotDataSuccess = (data) => ({
  type: FORGOT_DATA_SUCCESS,
  payload: data,
});
export const fetchForgotDataFailure = (error) => ({
  type: FORGOT_DATA_FAILURE,
  payload: error,
});

export const fetchResetDataRequest = () => ({
  type: RESET_DATA_REQUEST,
});

export const fetchResetDataSuccess = (data) => ({
  type: RESET_DATA_SUCCESS,
  payload: data,
});

export const fetchResetDataFailure = (error) => ({
  type: RESET_DATA_FAILURE,
  payload: error,
});

export const fetchRefreshTokenDataRequest = () => ({
  type: REFRESH_TOKEN_DATA_REQUEST,
});

export const fetchRefreshTokenDataSuccess = (data) => ({
  type: REFRESH_TOKEN_DATA_SUCCESS,
  payload: data,
});

export const fetchRefreshTokenDataFailure = (error) => ({
  type: REFRESH_TOKEN_DATA_FAILURE,
  payload: error,
});

export const fetchCurrentUserDataRequest = () => ({
  type: CURRENTUSER_DATA_REQUEST,
});

export const fetchCurrentUserWithRolesDataRequest = (data) => ({
  type: CURRENt_USER_WITH_ROLES_SUCCESS,
  payload: data,
});

export const fetchCurrentUserDataSuccess = (data) => ({
  type: CURRENTUSER_DATA_SUCCESS,
  payload: data,
});

export const fetchCurrentUserDataFailure = (error) => ({
  type: CURRENTUSER_DATA_FAILURE,
  payload: error,
});

export const fetchLocationSuccess = (data) => ({
  type: FETCH_LOCATION_SUCCESS,
  payload: data,
});

export const fetchLocationFailure = (error) => ({
  type: FETCH_LOCATION_FAILURE,
  payload: error,
});
export const fetchLocationRequest = () => ({
  type: FETCH_LOCATION_REQUEST,
});

export const fetchDistrictLocationSuccess = (data) => ({
  type: FETCH_DISTRICT_LOCATION_SUCCESS,
  payload: data,
});

export const fetchDistrictLocationFailure = (error) => ({
  type: FETCH_DISTRICT_LOCATION_FAILURE,
  payload: error,
});
export const fetchDistrictLocationRequest = () => ({
  type: FETCH_DISTRICT_LOCATION_REQUEST,
});
export const fetchContributionPlanBundleSuccess = (data) => ({
  type: FETCH_CONTRIBUTION_PLAN_SUCCESS,
  payload: data,
});

export const fetchContributionPlanBundleFailure = (error) => ({
  type: FETCH_CONTRIBUTION_PLAN_FAILURE,
  payload: error,
});
export const fetchContributionPlanBundleRequest = () => ({
  type: FETCH_CONTRIBUTION_PLAN_REQUEST,
});

export const fetchContributionPlanByIdBundleSuccess = (data) => ({

  type: FETCH_CONTRIBUTIONBYID_PLAN_SUCCESS,
  payload: data
});

export const fetchContributionPlanByIdBundleFailure = (error) => ({
  type: FETCH_CONTRIBUTIONBYID_PLAN_FAILURE,
  payload: error
});
export const fetchContributionPlanByIdBundleRequest = () => ({
  type: FETCH_CONTRIBUTIONBYID_PLAN_REQUEST
});

export const fetchInsureeByIdRequest = () => ({
  type: FETCH_INSUREEBYID_REQUEST
});

export const fetchInsureeByIdSuccess = (data) => ({
  type: FETCH_INSUREEBYID_SUCCESS,
  payload: data
});
export const fetchInsureeByIdFailure = (error) => ({
  type: FETCH_INSUREEBYID_FAILURE,
  payload: error
});

export const fetchPolicyHolderByInsureeRequest = () => ({
  type: FETCH_POLICYHOLDERINSUREE_REQUEST
});

export const fetchPolicyHolderByInsureeSuccess = (data) => ({
  type: FETCH_POLICYHOLDERINSUREE_SUCCESS,
  payload: data
});
export const fetchPolicyHolderByInsureeFailure = (error) => ({
  type: FETCH_POLICYHOLDERINSUREE_FAILURE,
  payload: error
});
export const fetchPolicyholderUserRequest = () => ({
  type: FETCH_POLICYHOLDER_USER_REQUEST,
});
export const fetchPolicyholderUserSuccess = (data) => ({
  type: FETCH_POLICYHOLDER_USER_SUCCESS,
  payload: data,
});

export const fetchPolicyholderUserFailure = (error) => ({
  type: FETCH_POLICYHOLDER_USER_FAILURE,
  payload: error,
});

export const fetchMunicipalityLocationFailure = (error) => ({
  type: FETCH_MUNICIPALITY_LOCATION_FAILURE,
  payload: error,
});
export const fetchMunicipalityLocationRequest = () => ({
  type: FETCH_MUNICIPALITY_LOCATION_REQUEST,
});
export const fetchMunicipalitySuccess = (data) => ({
  type: FETCH_MUNICIPALITY_LOCATION_SUCCESS,
  payload: data,
});

export const fetchAllLocationSuccess = (data, type) => ({
  type: FETCH_ALL_LOCATION_SUCCESS,
  payload: { data, type }, // Pass type along with data
});

export const fetchAllLocationFailure = (error, type) => ({
  type: FETCH_ALL_LOCATION_FAILURE,
  payload: { error, type }, // Pass type along with error
});

export const fetchAllLocationRequest = (type) => ({
  type: FETCH_ALL_LOCATION_REQUEST,
  payload: { type }, // Pass type along with request
});

export const fetchVillageLocationFailure = (error) => ({
  type: FETCH_VILLAGE_LOCATION_FAILURE,
  payload: error,
});
export const fetchVillageLocationRequest = () => ({
  type: FETCH_VILLAGE_LOCATION_REQUEST,
});
export const fetchVillageSuccess = (data) => ({
  type: FETCH_VILLAGE_LOCATION_SUCCESS,
  payload: data,
});

export const createPolicyHolderInsureeRequest = () => ({
  type: CREATE_POLICYHOLDERINSUREECREATE_REQUEST
});
export const createPolicyHolderInsureeSuccess = (data) => ({
  type: CREATE_POLICYHOLDERINSUREECREATE_SUCCESS,
  payload: data,
});
export const createPolicyHolderInsureeFailure = (error) => ({
  type: CREATE_POLICYHOLDERINSUREECREATE_FAILURE,
  payload: error,
});

export const updatePolicyHolderInsureeRequest = () => ({
  type: UPDATE_POLICYHOLDERINSUREEUPDATE_REQUEST,
});
export const updatePolicyHolderInsureeSuccess = (data) => ({
  type: UPDATE_POLICYHOLDERINSUREEUPDATE_SUCCESS,
  payload: data,
});
export const updatePolicyHolderInsureeFailure = (error) => ({
  type: UPDATE_POLICYHOLDERINSUREEUPDATE_FAILURE,
  payload: error,
});

export const deletePolicyHolderInsureeRequest = () => ({
  type: DELETE_POLICYHOLDERINSUREEDELETE_REQUEST,
});
export const deletePolicyHolderInsureeSuccess = (data) => ({
  type: DELETE_POLICYHOLDERINSUREEDELETE_SUCCESS,
  payload: data,
});
export const deletePolicyHolderInsureeFailure = (error) => ({
  type: DELETE_POLICYHOLDERINSUREEDELETE_FAILURE,
  payload: error,
});

export const printInsureeRequest = () => ({
  type: PRINT_INSUREE_REQUEST,
});
export const printInsureeSuccess = (data) => ({
  type: PRINT_INSUREE_SUCCESS,
  payload: data,
});
export const clearPrintInsureeSuccess = (data) => ({
  type: CLEAR_PRINT_INSUREE,
});
export const printInsureeFailure = (error) => ({
  type: PRINT_INSUREE_FAILURE,
  payload: error,
});

export const fetchMutationSuccess = (data) => ({
  type: CORE_MUTATION_RESP,
  payload: data,
});

export const fetchFileRequest = (data) => ({
  type: DOCUMENT_FILE_RESP,
  payload: data,
});

export const fetchDocumentRequest = (data) => ({
  type: DOCUMENT_DOCUMENTS_RESP,
  payload: data,
});

export const fetchFiletemplateSuccess = (data) => ({
  type: TEMPLATE_FILE_RESP,
  payload: data,
});

export const fetchUploadedSuccess = (data) => ({
  type: UPLOAD_FILE_RESP,
  payload: data,
});

export const fetchDeletedSuccess = (data) => ({
  type: DELETE_FILE_RESP,
  payload: data,
});

export const fetchContractRequest = (data) => ({
  type: FETCH_CONTRACT_REQUEST,
  payload: data,
});
export const fetchContractFailure = (data) => ({
  type: FETCH_CONTRACT_FAILURE,
  payload: data,
});
export const fetchContractSuccess = (data) => ({
  type: FETCH_CONTRACT_SUCCESS,
  payload: data,
});

export const fetchPaymentRequest = () => ({
  type: FETCH_PAYEMTS_REQUEST,
});

export const fetchPaymentSuccess = (data) => ({
  type: FETCH_PAYEMTS_SUCCESS,
  payload: data,
});

export const fetchPaymentFailure = (error) => ({
  type: FETCH_PAYEMTS_FAILURE,
  payload: error,
});

export const fetchPaymentByIdRequest = () => ({
  type: FETCH_PAYEMTSBYID_REQUEST,
});

export const fetchPaymentByIdSuccess = (data) => ({
  type: FETCH_PAYEMTSBYID_SUCCESS,
  payload: data,
});

export const fetchPaymentByIdFailure = (error) => ({
  type: FETCH_PAYEMTSBYID_FAILURE,
  payload: error,
});

export const fetchEndDateRequest = (data) => ({
  type: FETCH_ENDATE_REQUEST,
  payload: data,
});

export const fetchEndDateFailure = (error) => ({
  type: FETCH_ENDATE_FAILURE,
  payload: error,
});

export const fetchEndDateSuccess = (data) => ({
  type: FETCH_ENDATE_SUCCESS,
  payload: data,
});

export const fetchCreateContractRequest = (error) => ({
  type: FETCH_CREATE_CONTRACT_REQUEST,
  payload: error,
});

export const fetchCreateContractFailure = (error) => ({
  type: FETCH_CREATE_CONTRACT_FAILURE,
  payload: error,
});

export const fetchCreateContractSuccess = (data) => ({
  type: FETCH_CREATE_CONTRACT_SUCCESS,
  payload: data,
});

export const fetchContractDetailsRequest = (error) => ({
  type: FETCH_CONTRACT_DETAILS_REQUEST,
  payload: error,
});

export const fetchContractDetailsFailure = (error) => ({
  type: FETCH_CONTRACT_DETAILS_FAILURE,
  payload: error,
});

export const fetchContractDetailsSuccess = (data) => ({
  type: FETCH_CONTRACT_DETAILS_SUCCESS,
  payload: data,
});

export const fetchPolicyholderInsureeRequest = (error) => ({
  type: FETCH_POLICYHOLDER_INSUREE_REQUEST,
  payload: error,
});

export const fetchPolicyholderInsureeFailure = (error) => ({
  type: FETCH_POLICYHOLDER_INSUREE_FAILURE,
  payload: error,
});

export const fetchPolicyholderInsureeSuccess = (data) => ({
  type: FETCH_POLICYHOLDER_INSUREE_SUCCESS,
  payload: data,
});

export const deleteContractRequest = () => ({
  type: FETCH_CONTRACT_DELETE_REQUEST,
});
export const deleteContractSuccess = (data) => ({
  type: FETCH_CONTRACT_DELETE_SUCCESS,
  payload: data,
});
export const deleteContractFailure = (error) => ({
  type: FETCH_CONTRACT_DELETE_FAILURE,
  payload: error,
});

export const updatePaymentRequest = () => ({
  type: UPDATE_PAYMENT_REQUEST,
});
export const updatePaymentSuccess = (data) => ({
  type: UPDATE_PAYMENT_SUCCESS,
  payload: data,
});
export const updatePaymentFailure = (error) => ({
  type: UPDATE_PAYMENT_FAILURE,
  payload: error,
});

export const submitContractRequest = () => ({
  type: SUBMIT_CONTRACT_REQUEST,
});
export const submitContractSuccess = (data) => ({
  type: SUBMIT_CONTRACT_SUCCESS,
  payload: data,
});
export const submitContractFailure = (error) => ({
  type: SUBMIT_CONTRACT_FAILURE,
  payload: error,
});

export const deleteContractDetailRequest = () => ({
  type: DELETE_CONTRACT_DETAIL_REQUEST,
});
export const deleteContractDetailSuccess = (data) => ({
  type: DELETE_CONTRACT_DETAIL_SUCCESS,
  payload: data,
});
export const deleteContractDetailFailure = (error) => ({
  type: DELETE_CONTRACT_DETAIL_FAILURE,
  payload: error,
});

export const initializeRoutes = (routes) => ({
  type: INITIALIZE_ROUTES,
  payload: routes,
});

export const fetchValidationRequest = (data) => ({
  type: FETCH_USER_VALIDATION_REQUEST,
  payload: data,
});

export const fetchValidationFailure = (error) => ({
  type: FETCH_USER_VALIDATION_FAILURE,
  payload: error,
});

export const fetchValidationSuccess = (data) => ({
  type: FETCH_USER_VALIDATION_SUCCESS,
  payload: data,
});

export const printPolicyholderRequest = () => ({
  type: PRINT_POLICYHOLDER_REQUEST,
});
export const printPolicyholderSuccess = (data) => ({
  type: PRINT_POLICYHOLDER_SUCCESS,
  payload: data,
});

export const printPolicyholderFailure = (error) => ({
  type: PRINT_POLICYHOLDER_FAILURE,
  payload: error,
});


// for verification list
export const fetchVerificationListRequest = () => ({
  type: FETCH_VERIFICATION_DATA_REQUEST,
});


export const fetchVerificationListSuccess = (data) => ({
  type: FETCH_VERIFICATION_DATA_SUCCESS,
  payload: data,
});


export const fetchVerificationListFailure = (error) => ({
  type: FETCH_VERIFICATION_DATA_FAILURE,
  payload: error,
});

export const fetchVerificationCodeRequest = () => ({
  type: FETCH_VERIFICATION_CODE_REQUEST,
});

export const cleanVerificationCode = () => ({
  type: CLEAN_VERIFICATION_CODE,
});

export const cleanSelectedInsuree = () => ({
  type: CLEAN_SELECTED_INSUREE,
});

export const fetchVerificationCodeSuccess = (data) => ({
  type: FETCH_VERIFICATION_CODE_SUCCESS,
  payload: data,
});


export const fetchVerificationCodeFailure = (error) => ({
  type: FETCH_VERIFICATION_CODE_FAILURE,
  payload: error,
});


// FOR HEALTH INSURANCE
export const fetchHealthFacilityRequest = () => ({
  type: FETCH_HEALTH_FACILITIES_REQUEST,
});


export const fetchHealthFacilitySuccess = (data) => ({
  type: FETCH_HEALTH_FACILITIES_SUCCESS,
  payload: data,
});


export const fetchHealthFacilityFailure = (error) => ({
  type: FETCH_HEALTH_FACILITIES_FAILURE,
  payload: error,
});

export const fetchConventionnementByHFIdRequest = () => ({
  type: FETCH_CONVENTIONNEMENT_BY_HF_ID_REQUEST,
});

export const fetchConventionnementByHFIdSuccess = (data) => ({
  type: FETCH_CONVENTIONNEMENT_BY_HF_ID_SUCCESS,
  payload: data,
});


export const fetchConventionnementByHFIdFailure = (error) => ({
  type: FETCH_CONVENTIONNEMENT_BY_HF_ID_FAILURE,
  payload: error,
});

export const fetchHealthFacilitiesWithPackageRequest = () => ({
  type: FETCH_HEALTH_FACILITIES_PACKAGE_REQUEST,
});

export const fetchHealthFacilitiesWithPackageSuccess = (data) => ({
  type: FETCH_HEALTH_FACILITIES_PACKAGE_SUCCESS,
  payload: data,
});

export const fetchHealthFacilitiesWithPackageFailure = (error) => ({
  type: FETCH_HEALTH_FACILITIES_PACKAGE_FAILURE,
  payload: error,
});

export const fetchHealthFacilitiesWithProductBundleRequest = () => ({
  type: FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_REQUEST,
});

export const fetchHealthFacilitiesWithProductBundleSuccess = (data) => ({
  type: FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_SUCCESS,
  payload: data,
});

export const fetchHealthFacilitiesWithProductBundleFailure = (error) => ({
  type: FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_FAILURE,
  payload: error,
});

export const fetchInsureeHealthFacilityRequest = () => ({
  type: FETCH_HEALTH_FACILITIES_INUSREE_REQUEST,
});


export const fetchInsureeHealthFacilitySuccess = (data) => ({
  type: FETCH_HEALTH_FACILITIES_INUSREE_SUCCESS,
  payload: data,
});


export const fetchInsureeHealthFacilityFailure = (error) => ({
  type: FETCH_HEALTH_FACILITIES_INUSREE_FAILURE,
  payload: error,
});

export const fetchStatusHealthFacilityRequest = () => ({
  type: FETCH_HEALTH_FACILITIES_INUSREE_STATUS_REQUEST,
});


export const fetchStatusHealthFacilitySuccess = (data) => ({
  type: FETCH_HEALTH_FACILITIES_INUSREE_STATUS_SUCCESS,
  payload: data,
});


export const fetchStatusHealthFacilityFailure = (error) => ({
  type: FETCH_HEALTH_FACILITIES_INUSREE_STATUS_FAILURE,
  payload: error,
});

export const fetchStatusHealthFacilitySubstituteRequest = () => ({
  type: FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_REQUEST,
});

export const fetchStatusHealthFacilitySubstituteSuccess = (data) => ({
  type: FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_SUCCESS,
  payload: data,
});

export const fetchStatusHealthFacilitySubstituteFailure = (error) => ({
  type: FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_FAILURE,
  payload: error,
});

export const fetchVerificationHistoryRequest = () => ({
  type: FETCH_VERIFICATION_HISTORY_REQUEST,
});


export const fetchVerificationHistorySuccess = (data) => ({
  type: FETCH_VERIFICATION_HISTORY_SUCCESS,
  payload: data,
});


export const fetchVerificationHistoryFailure = (error) => ({
  type: FETCH_VERIFICATION_HISTORY_FAILURE,
  payload: error,
});

export const fetchPoliciesByInsureeRequest = () => ({
  type: FETCH_POLICIES_INSUREE_REQUEST,
});


export const fetchPoliciesByInsureeSuccess = (data) => ({
  type: FETCH_POLICIES_INSUREE_SUCCESS,
  payload: data,
});


export const fetchPoliciesByInsureeFailure = (error) => ({
  type: FETCH_POLICIES_INSUREE_FAILURE,
  payload: error,
});

export const fetchLatestActiveInsureePolicyRequest = () => ({
  type: FETCH_LATEST_ACTIVE_INSUREE_REQUEST,
});


export const fetchLatestActiveInsureePolicySuccess = (data) => ({
  type: FETCH_LATEST_ACTIVE_INSUREE_SUCCESS,
  payload: data,
});


export const fetchLatestActiveInsureePolicyFailure = (error) => ({
  type: FETCH_LATEST_ACTIVE_INSUREE_FAILURE,
  payload: error,
});

export const fetchGuardianRequest = () => ({
  type: FETCH_GUARDIAN_REQUEST,
});


export const fetchGuardianSuccess = (data) => ({
  type: FETCH_GUARDIAN_SUCCESS,
  payload: data,
});


export const fetchGuardianFailure = (error) => ({
  type: FETCH_GUARDIAN_FAILURE,
  payload: error,
});

// roles request
export const fetchRolesRequest = () => ({
  type: FETCH_ROLES_REQUEST,
})

export const fetchRolesSuccess = (data) => ({
  type: FETCH_ROLES_SUCCESS,
  payload: data,
})

export const fetchRolesFailure = (error) => ({
  type: FETCH_ROLES_FAILURE,
  payload: error,
})

// admin table
export const fetchAdminTableRequest = () => ({
  type: FETCH_ADMIN_TABLE_REQUEST,
});

export const fetchAdminTableSuccess = (data) => ({
  type: FETCH_ADMIN_TABLE_SUCCESS,
  payload: data,
})

export const fetchAdminTableFailure = (error) => ({
  type: FETCH_ADMIN_TABLE_FAILURE,
  payload: error,
})

// admin create table
export const createAdminRequest = () => ({
  type: CREATE_ADMIN_REQUEST,
});

export const createAdminSuccess = (data) => ({
  type: CREATE_ADMIN_SUCCESS,
  payload: data,
});

export const createAdminFailure = (error) => ({
  type: CREATE_ADMIN_FAILURE,
  payload: error,
});

// admin fetch
export const fetchAdminRequest = () => ({
  type: FETCH_ADMIN_REQUEST,
});

export const resetUsernameError = () => ({
  type: RESET_USERNAME_ERROR,
});

export const fetchAdminSuccess = (data) => ({
  type: FETCH_ADMIN_SUCCESS,
  payload: data,
});

export const fetchAdminFailure = (error) => ({
  type: FETCH_ADMIN_FAILURE,
  payload: error,
}); 

// edit admin
export const editAdminRequest = () => ({
  type: EDIT_ADMIN_REQUEST,
});

export const editAdminSuccess = (data) => ({
  type: EDIT_ADMIN_SUCCESS,
  payload: data,
});

export const editAdminFailure = (error) => ({
  type: EDIT_ADMIN_FAILURE,
  payload: error,
});

// delete admin
export const deleteAdminRequest = () => ({
  type: DELETE_ADMIN_REQUEST,
});

export const deleteAdminSuccess = (data) => ({
  type: DELETE_ADMIN_SUCCESS,
  payload: data,
});

export const deleteAdminFailure = (error) => ({
  type: DELETE_ADMIN_FAILURE,
  payload: error,
});


// claim table 
export const fetchClaimTableRequest = () => ({
  type: FETCH_CLAIM_TABLE_REQUEST,
});


export const fetchClaimTableSuccess = (data) => ({
  type: FETCH_CLAIM_TABLE_SUCCESS,
  payload: data,
})
export const fetchInsureeClaimServiceRequest = () => ({
  type: FETCH_CLAIM_SERVICE_REQUEST,
});


export const fetchInsureeClaimServiceSuccess = (data) => ({
  type: FETCH_CLAIM_SERVICE_SUCCESS,
  payload: data,
});


export const fetchClaimTableFailure = (error) => ({
  type: FETCH_CLAIM_TABLE_FAILURE,
  payload: error,
})

export const fetchInsureeClaimServiceFailure = (error) => ({
  type: FETCH_CLAIM_SERVICE_FAILURE,
  payload: error,
});

export const fetchInsureeItemServiceRequest = () => ({
  type: FETCH_CLAIM_ITEMS_REQUEST,
});

export const fetchInsureeItemServiceSuccess = (data) => ({
  type: FETCH_CLAIM_ITEMS_SUCCESS,
  payload: data,
});

export const fetchInsureeItemServiceFailure = (error) => ({
  type: FETCH_CLAIM_ITEMS_FAILURE,
  payload: error,
});


export const fetchPathologyRequest = () => ({
  type: FETCH_PATHOLOGY_REQUEST,
});

export const fetchPathologySuccess = (data) => ({
  type: FETCH_PATHOLOGY_SUCCESS,
  payload: data,
});

export const fetchPathologyFailure = (error) => ({
  type: FETCH_PATHOLOGY_FAILURE,
  payload: error,
});

export const createClaimRequest = () => ({
  type: CREATE_CLAIM_REQUEST,
});

export const createClaimSuccess = (data) => ({
  type: CREATE_CLAIM_SUCCESS,
  payload: data,
});

export const createClaimFailure = (error) => ({
  type: CREATE_CLAIM_FAILURE,
  payload: error,
});

export const fetchConsultantHfRequest = () => ({
  type: FETCH_CONSULTANT_HF_REQUEST,
});


export const fetchConsultantHfSuccess = (data) => ({
  type: FETCH_CONSULTANT_HF_SUCCESS,
  payload: data,
});


export const fetchConsultantHfFailure = (error) => ({
  type: FETCH_CONSULTANT_HF_FAILURE,
  payload: error,
});

export const printCareSheetRequest = () => ({
  type: FETCH_PRINT_CARE_SHEET_REQUEST,
});


export const printCareSheetSuccess = (data) => ({
  type: FETCH_PRINT_CARE_SHEET_SUCCESS,
  payload: data,
});


export const printCareSheetFailure = (error) => ({
  type: FETCH_PRINT_CARE_SHEET_FAILURE,
  payload: error,
});

export const createFosaUserRequest = () => ({
  type: CREATE_FOSA_USER_REQUEST,
});


export const createFosaUserSuccess = (data) => ({
  type: CREATE_FOSA_USER_SUCCESS,
  payload: data,
});


export const createFosaUserFailure = (error) => ({
  type: CREATE_FOSA_USER_FAILURE,
  payload: error,
});

export const fetchClaimByIdRequest = () => ({
  type: FETCH_CLAIMBYID_REQUEST,
});

export const fetchClaimByIdSuccess = (data) => ({
  type: FETCH_CLAIMBYID_SUCCESS,
  payload: data,
});

export const fetchClaimByIdFailure = (error) => ({
  type: FETCH_CLAIMBYID_FAILURE,
  payload: error,
});

export const fetchClaimHistoryByIdRequest = () => ({
  type: FETCH_CLAIMHISTORYBYID_REQUEST,
});

export const fetchClaimHistoryByIdSuccess = (data) => ({
  type: FETCH_CLAIMHISTORYBYID_SUCCESS,
  payload: data,
});

export const fetchClaimHistoryByIdFailure = (error) => ({
  type: FETCH_CLAIMHISTORYBYID_FAILURE,
  payload: error,
});

export const fetchAdminIdRequest = () => ({
  type: FETCH_ADMINID_REQUEST,
});

export const fetchAdminIdSuccess = (data) => ({
  type: FETCH_ADMINID_SUCCESS,
  payload: data,
});

export const fetchAdminIdFailure = (error) => ({
  type: FETCH_ADMINID_FAILURE,
})

export const getConsultantHfInsureeRequest = () => ({
  type: GET_CONSULTANT_REQUEST,
});


export const getConsultantHfInsureeSuccess = (data) => ({
  type: GET_CONSULTANT_SUCCESS,
  payload: data,
});


export const getConsultantHfInsureeFailure = (error) => ({
  type: GET_CONSULTANT_FAILURE,
  payload: error,
});

export const fetchMedicalStaffInsureeRequest = () => ({
  type: FETCH_MEDICAL_INSUREE_REQUEST,
});


export const fetchMedicalStaffInsureeSuccess = (data) => ({
  type: FETCH_MEDICAL_INSUREE_SUCCESS,
  payload: data,
});


export const fetchMedicalStaffInsureeFailure = (error) => ({
  type: FETCH_MEDICAL_INSUREE_FAILURE,
  payload: error,
});
export const fetchFosaUserRequest = () => ({
  type: FETCH_FOSA_USER_REQUEST,
});


export const fetchFosaUserSuccess = (data) => ({
  type: FETCH_FOSA_USER_SUCCESS,
  payload: data,
});


export const fetchFosaUserFailure = (error) => ({
  type: FETCH_FOSA_USER_FAILURE,
  payload: error,
});

export const fetchFosaMedicalItemsRequest = () => ({
  type: FETCH_FOSA_MEDICAL_ITEMS_REQUEST
});

export const fetchFosaMedicalItemsSuccess = (data) => ({
  type: FETCH_FOSA_MEDICAL_ITEMS_SUCCESS,
  payload: data,
});


export const fetchFosaMedicalItemsFailure = (error) => ({
  type: FETCH_FOSA_MEDICAL_ITEMS_FAILURE,
  payload: error,
});

export const fetchFosaMedicalServicesRequest = () => ({
  type: FETCH_FOSA_MEDICAL_SERVICES_REQUEST
});

export const fetchFosaMedicalServicesSuccess = (data) => ({
  type: FETCH_FOSA_MEDICAL_SERVICES_SUCCESS,
  payload: data,
});


export const fetchFosaMedicalServicesFailure = (error) => ({
  type: FETCH_FOSA_MEDICAL_SERVICES_FAILURE,
  payload: error,
});

export const fetchInsureeByUuidRequest = () => ({
  type: FETCH_INSUREEUUID_REQUEST
});

export const fetchInsureeByUuidSuccess = (data) => ({
  type: FETCH_INSUREEUUID_SUCCESS,
  payload: data
});
export const fetchInsureeByUuidFailure = (error) => ({
  type: FETCH_INSUREEUUID_FAILURE,
  payload: error
});

export const fetchSubstituteRequest = () => ({
  type: FETCH_SUBSTITUTE_REQUEST,
});

export const fetchSubstituteSuccess = (data) => ({
  type: FETCH_SUBSTITUTE_SUCCESS,
  payload: data
});

export const fetchSubstituteFailure = (error) => ({
  type: FETCH_SUBSTITUTE_FAILURE,
  payload: error
});

export const submitClaimRequest = () => ({
  type: SUBMIT_CLAIM_REQUEST,
});

export const submitClaimSuccess = (data) => ({
  type: SUBMIT_CLAIM_SUCCESS,
  payload: data,
});

export const submitClaimFailure = (error) => ({
  type: SUBMIT_CLAIM_FAILURE,
  payload: error,
});

export const resetClaimState = () => ({
  type: RESET_CLAIM_STATE,
});

export const updateClaimRequest = () => ({
  type: UPDATE_CLAIM_REQUEST,
});

export const updateClaimSuccess = (data) => ({
  type: UPDATE_CLAIM_SUCCESS,
  payload: data,
});

export const updateClaimFailure = (error) => ({
  type: UPDATE_CLAIM_FAILURE,
  payload: error,
});

export const createAttachmentRequest = () => ({
  type: CREATE_ATTACHMENT_REQUEST,
});

export const createAttachmentSuccess = (data) => ({
  type: CREATE_ATTACHMENT_SUCCESS,
  payload: data,
});

export const createAttachmentFailure = (error) => ({
  type: CREATE_ATTACHMENT_FAILURE,
  payload: error,
});

export const fetchAttachmentsRequest = () => ({
  type: FETCH_ATTACHEMENTS_REQUEST
});

export const fetchAttachmentsSuccess = (data) => ({
  type: FETCH_ATTACHEMENTS_SUCCESS,
  payload: data
});
export const fetchAttachmentsFailure = (error) => ({
  type: FETCH_ATTACHEMENTS_FAILURE,
  payload: error
});

export const clearCareSheetData = () => ({
  type: CLEAR_CARESHEET_DATA,
});
export const clearClaimResp = () => ({
  type: CLEAR_CLAIM_RESP,
});


export const fetchPreAuthTableRequest = () => ({
  type: FETCH_PREAUTH_REQUEST
});

export const fetchPreAuthTableSuccess = (data) => ({
  type: FETCH_PREAUTH_SUCCESS,
  payload: data
});
export const fetchPreAuthTableFailure = (error) => ({
  type: FETCH_PREAUTH_FAILURE,
  payload: error
});


export const fetchPreauthFormDataRequest = () => ({
  type: FETCH_PREAUTHFORM_REQUEST
});

export const fetchPreauthFormDataSuccess = (data) => ({
  type: FETCH_PREAUTHFORM_SUCCESS,
  payload: data
});
export const fetchPreauthFormDataFailure = (error) => ({
  type: FETCH_PREAUTHFORM_FAILURE,
  payload: error
});

export const fetchPreauthHistoryRequest = () => ({
  type: FETCH_PREAUTH_HISTORY_REQUEST
});

export const fetchPreauthHistorySucess = (data) => ({
  type: FETCH_PREAUTH_HISTORY_SUCCESS,
  payload: data
});
export const fetchPreauthHistoryFailure = (error) => ({
  type: FETCH_PREAUTH_HISTORY_FAILURE,
  payload: error
});

export const fetchNotificationsRequest = () => ({
  type: FETCH_NOTIFICATIONS_REQUEST
});

export const fetchNotificationsSucess = (data) => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload: data
});

export const fetchNotificationsFailure = (error) => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
  payload: error
});

export const GetPreauthDataRequest = () => ({
  type: GET_PREAUTH_REQUEST
});

export const GetPreauthDataSuccess = (data) => ({
  type: GET_PREAUTH_SUCCESS,
  payload: data
});

export const GetPreauthDataFailure = (error) => ({
  type: GET_PREAUTH_FAILURE,
  payload: error
});


export const createPreAuthRequest = () => ({
  type: CREATE_PREAUTH_REQUEST,
});

export const createPreAuthSuccess = (data) => ({
  type: CREATE_PREAUTH_SUCCESS,
  payload: data,
});

export const createPreAuthFailure = (error) => ({
  type: CREATE_PREAUTH_FAILURE,
  payload: error,
});

export const fetchClaimChatRequest = () => ({
  type: FETCH_CLAIM_CHAT_REQUEST,
});

export const fetchClaimChatSuccess = (data) => ({
  type: FETCH_CLAIM_CHAT_SUCCESS,
  payload: data,
});

export const fetchClaimChatFailure = (error) => ({
  type: FETCH_CLAIM_CHAT_FAILURE,
  payload: error,
});

export const createClaimChatRequest = () => ({
  type: CREATE_CLAIM_CHAT_REQUEST,
});

export const createClaimChatSuccess = (data) => ({
  type: CREATE_CLAIM_CHAT_SUCCESS,
  payload: data,
});

export const createClaimChatFailure = (error) => ({
  type: CREATE_CLAIM_CHAT_FAILURE,
  payload: error,
});